import React, { useEffect, useState, useCallback } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import { SvgImages } from "../../Utils/LocalImages";
import { ImageFilters } from "../../Utils/Enums";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import RoutesPath from "../../Utils/RoutesPath";
import CustomTextEditor from "../../Components/Reusable/CustomTextEditor";
import PackagesService from "../../Services/PackagesService";
import MockTestService from "../../Services/MockTestService";
import DataProvider from "../../Utils/DataProvider";
import ClassService from "../../Services/ClassService";


const AddPackages = () => {
    const [packs, setpacks] = useState([]);
    const [classes, setClasses] = useState([]);
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [packages, setPackages] = useState({ ...useLocation().state });
    // const [uploadedDocuments, setUploadedDocuments] = useState(Array());
    const [uploadedDocuments1, setUploadedDocuments1] = useState(Array());
    const [question, setQuestion] = useState({ ...useLocation().state });
    const [deleteInput, setDeleteInput] = useState(false)
    const [additionalInputs, setAdditionalInputs] = useState([
        { name: "mocktest0", value: "noOfAttempts0" },
    ]);
    const [resetMockTest, setResetMockTest] = useState(false);
    const [resetMedium, setResetMedium] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [bharatSatExam, setBharatSatExam] = useState(packages.isBharatSAT || false);
    const [paidsyllabus, setPaidSyllabus] = useState(packages.paidSyllabus || false);
    const [ismocktest, setIsMocktest] = useState(packages.isMockTest || false);

    const navigate = useNavigate();

    const [stepOneValidations, setStepOneValidations] = useState(
        Yup.object().shape({
            // mocktest0: validationRegex.required,
            // noOfAttempts0: validationRegex.required,
            packagename: validationRegex.required,
            details: validationRegex.required,
            actualPrice: validationRegex.required,
            // discountedPrice: validationRegex.required,
            // discountCoordinator: validationRegex.required,
            validityInDays: validationRegex.required,
            // featuredImage: validationRegex.required,
            mainImage: validationRegex.required,
            class_id: validationRegex.required,
            medium: validationRegex.required,

        })
    );

    const {
        register: registerStepOne,
        handleSubmit: handleSubmit,
        setValue: setValuesStepOne,
        formState: { errors: errorsStepOne, },
        getValues: getValuesStepOne,
    } = useForm({
        resolver: yupResolver(stepOneValidations),
        defaultValues: {
            packagename: packages?.packageName || "",
            details: packages?.details || "",
            actualPrice: packages?.actualPrice || "",
            discountedPrice: packages?.discountedPrice || "",
            discountCoordinator: packages?.discountCoordinator || "",
            validityInDays: packages?.validityInDays || "",
            // featuredImage: packages?.featuredImage || "",
            mainImage: packages?.mainImage || "",
            class_id: packages?.class_id?._id || "",
            medium: packages?.medium || "",
            testName: packages?.testName || "",
            bharatSatExam: packages?.isBharatSAT || false,
            paidsyllabus: packages?.isPaidSyllabus || false,
            ismocktest: packages?.isMockTest || false,

        },
    });

    const getAllClasses = async () => {
        try {
            const response = await ClassService.getAllClassesWithoutPagination();
            setClasses(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const fetchData = async () => {
        try {
            const response = await MockTestService.getAllMockTestWithoutPagination(getValuesStepOne("class_id") || "", getValuesStepOne("medium") || "");
            setpacks(getValuesStepOne("class_id") && getValuesStepOne("medium") ? response.data : []);
        } catch (error) {
            console.error(error);
            handleApiErrors(error);
        }
    };

    const onSubmit = async (packagesData) => {
        const { class_id, medium, actualPrice, discountedPrice, discountCoordinator } = packagesData;
        // Extract the integer part of the price values
        const actualPriceInt = Math.floor(actualPrice);
        const discountedPriceInt = Math.floor(discountedPrice);
        const discountCoordinatorInt = Math.floor(discountCoordinator);

        if (actualPriceInt < 0 || discountedPriceInt < 0 || discountCoordinatorInt < 0) {
            toast.error("Price values cannot be negative!");
            return;
        }

        // Check if actual price's integer part is less than discounted price's integer part
        if (actualPriceInt < discountedPriceInt) {
            toast.error("Discounted price can't be greater than Actual price.");
            return;
        } else if (actualPriceInt >= 0 && discountedPriceInt >= 0) {
            if (discountCoordinatorInt > discountedPriceInt) {
                toast.error("Coordinator Discount price can't be greater than Discounted price.");
                return;
            }
        }

        if (discountCoordinatorInt > actualPriceInt) {
            toast.error("Coordinator Discount price can't be greater than Actual price.");
            return;
        }

        let mockTestData = []
        let isValid = true;
        additionalInputs.forEach((item) => {
            const numberOfAttempts = getValuesStepOne(item.value);
            // Validate that numberOfAttempts is not negative
            if (numberOfAttempts < 0) {
                toast.error("Number of attempts cannot be negative!");
                isValid = false;
                return;
            }
            mockTestData.push({
                "mockTest": getValuesStepOne(item.name),
                "numberOfAttempts": numberOfAttempts
            });
        })
        if (!isValid) return;
        // Validate that at least one of the fields is provided
        // const isMockTestDataValid = mockTestData.some(data => data.mockTest && data.numberOfAttempts);
        if ((!ismocktest && !bharatSatExam && !paidsyllabus)) {
            toast.error("Please provide at least one of the following: Select Mock Test, Bharat Sat Exam, or Pradnya Learnitics.");
            return;
        }
        try {
            const response = await PackagesService.addPackages(
                packages?._id || "",
                packagesData.packagename,
                packagesData.validityInDays,
                packagesData.actualPrice,
                packagesData.discountedPrice,
                // uploadedDocuments,
                uploadedDocuments1,
                JSON.stringify(mockTestData), // mockTests
                packagesData.discountCoordinator,
                packagesData.details,
                bharatSatExam,
                paidsyllabus,
                ismocktest,
                class_id,
                medium,
            );

            toast.success(response.message);
            navigate(RoutesPath.viewPackages);
            setPackages({})
        } catch (error) {
            // Handle API errors
            handleApiErrors(error);
        }
    };

    useEffect(() => {
        fetchData();
        getAllClasses()
        if (packages && packages.mockTests) {
            const subjectInputs = []
            packages.mockTests.forEach((data, index) => {
                console.log(data, 'data')
                addValidation(`mocktest${index}`, validationRegex.required)
                addValidation(`noOfAttempts${index}`, validationRegex.required)
                subjectInputs.push({ name: `mocktest${index}`, value: `noOfAttempts${index}` });
                setValuesStepOne(`noOfAttempts${index}`, data?.numberOfAttempts)
                setValuesStepOne(`mocktest${index}`, data?.mockTest?._id)
            })
            setAdditionalInputs(subjectInputs)
        }
    }, []);

    // Handler to add validation dynamically
    const addValidation = useCallback((fieldName, validationSchema) => {
        setStepOneValidations((prevSchema) => prevSchema.shape({ [fieldName]: validationSchema }));
    }, []);

    // Handler to remove validation dynamically
    const removeValidation = useCallback((fieldName) => {
        setStepOneValidations((prevSchema) => {
            const { [fieldName]: _, ...rest } = prevSchema.fields; // Remove the specific field
            return Yup.object().shape(rest);
        });
    }, []);

    // const handleAddMore = () => {
    //     addValidation(`mocktest${additionalInputs.length}`, validationRegex.required)
    //     addValidation(`noOfAttempts${additionalInputs.length}`, validationRegex.required)
    //     setAdditionalInputs([...additionalInputs, { name: `mocktest${additionalInputs.length}`, value: `noOfAttempts${additionalInputs.length}` }]);
    //     console.log(additionalInputs, 'additional');

    //     setDeleteInput(true);
    // };

    // const handleDelete = (index) => {
    //     console.log(index, 'index');
    //     const newInputs = [...additionalInputs];
    //     newInputs.splice(index, 1);
    //     removeValidation(additionalInputs[index].name)
    //     removeValidation(additionalInputs[index].value)
    //     setAdditionalInputs(newInputs);
    //     console.log(newInputs, 'newInputs');
    //     console.log(additionalInputs, 'additional');

    //     if (newInputs.length === 1) {
    //         setDeleteInput(false);
    //     }
    // };
    const handleAddMore = () => {
        const newIndex = additionalInputs.length;
        addValidation(`subjects${newIndex}`, validationRegex.required);
        addValidation(`noOfQuestions${newIndex}`, validationRegex.required);
        // Add a new input field with a unique index
        setAdditionalInputs([
            ...additionalInputs,
            { name: `subjects${newIndex}`, value: `noOfQuestions${newIndex}` }
        ]);
        // Reset the mock test dropdown and attempts field for the new entry
        setValuesStepOne(`subjects${newIndex}`, "");
        setValuesStepOne(`noOfQuestions${newIndex}`, "");
        setDeleteInput(true);
    };

    const handleDelete = (index) => {
        // Remove the validation for the field being deleted
        removeValidation(additionalInputs[index].name);
        removeValidation(additionalInputs[index].value);
        // Remove the input field
        const newInputs = [...additionalInputs];
        newInputs.splice(index, 1);
        // Update the state with the remaining input fields
        setAdditionalInputs(newInputs);
        // Reset the delete input button state
        if (newInputs.length === 1) {
            setDeleteInput(false);
        }
    };
    useEffect(() => {
        if (packages._id) {
            setIsEditMode(true);
        } else {
            setIsEditMode(false);
        }
    }, [packages]);

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between">
                <h1 className="black fs-18 fw-600 mb-0">PACKAGES</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">Packages</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <div className="table_title ps-2">
                    <div className="table_headings">
                        <h1 className="black fs-18 fw-600 mb-0">
                            {isEditMode ? "Edit Packages" : "Add Packages"}
                        </h1>
                    </div>

                    <form className="" onSubmit={handleSubmit(onSubmit)}>
                        <div className="row profile_inputs w-100 mt-4">
                            <div className="col-md-12">
                                <CustomTextField
                                    labelTitle="Package Name"
                                    placeholder="Package Name"
                                    name="packagename"
                                    id="packagename"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    showMandatory={true}
                                    register={registerStepOne}
                                    showError={errorsStepOne?.packagename}
                                    errorMessage={errorsStepOne?.packagename?.message}
                                />
                            </div>

                            {/* <div className="col-md-6 mb-3">
                                <label className="login_heading">Featured Image<span className="danger fs-14 fw-400 mt-1">*(Extension: jpg. jpeg.webp) Note:Dimension Size 1000x600 px</span></label>
                                <div className="position-relative select_file ">
                                    <input className="choose-file"
                                        type="file"
                                        name="featuredImage"
                                        accept="image/jpeg, image/jpg, image/webp"
                                        {...registerStepOne("featuredImage")}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                const file = e.target.files[0];
                                                const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                                                if (!validTypes.includes(file.type)) {
                                                    toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                                                    e.target.value = null; // Clear the input value
                                                } else {
                                                    setUploadedDocuments(file);
                                                }
                                            }
                                        }}
                                    />

                                </div>
                                {packages.featuredImage && (
                                    <p className="text-success fs-14 fw-400 my-1">Selected file: {packages.featuredImage}</p>
                                )}
                                {errorsStepOne.featuredImage && (
                                    <p className="danger fs-14 fw-400 my-1">{errorsStepOne.featuredImage.message}</p>
                                )}
                            </div> */}

                            <div className="col-md-6">
                                {classes && classes.length != 0 && (
                                    <CustomDropDown
                                        labelTitle="Select Class"
                                        placeholder="Select"
                                        name="class_id"
                                        id="class_id"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showError={errorsStepOne?.class_id}
                                        errorMessage={errorsStepOne?.class_id?.message}
                                        showMandatory={true}
                                        onChange={() => {
                                            additionalInputs.forEach((input) => {
                                                setValuesStepOne(input.name, "");
                                            })
                                            setResetMockTest(true);
                                            setValuesStepOne("medium", "");
                                            setResetMedium(true)
                                            fetchData()
                                        }}
                                        setValue={setValuesStepOne}
                                        options={classes?.map((e) => {
                                            return { value: e._id, label: e.class_name };
                                        })}
                                        defaultOption={() => {
                                            if (packages?.class_id?._id && classes) {
                                                const matchingClass = classes.find(
                                                    (value) => value._id === packages.class_id?._id
                                                );
                                                if (matchingClass) {
                                                    return {
                                                        value: matchingClass._id,
                                                        label: matchingClass.class_name,
                                                    };
                                                }
                                            }
                                            return null;
                                        }}
                                    />
                                )}
                            </div>
                            <div className="col-md-6">
                                <CustomDropDown
                                    labelTitle="Select Medium"
                                    placeholder="Select"
                                    name="medium"
                                    id="medium"
                                    additionalClasses="profile_edit"
                                    setResetValue={setResetMedium}
                                    resetValue={resetMedium}
                                    inputType={InputType.text}
                                    showError={errorsStepOne?.medium}
                                    errorMessage={errorsStepOne?.medium?.message}
                                    showMandatory={true}
                                    setValue={setValuesStepOne}
                                    onChange={() => {
                                        fetchData()
                                    }}
                                    options={DataProvider.mediumList}
                                    defaultOption={() => {
                                        return question.medium
                                            ? { value: question.medium, label: question.medium }
                                            : null;
                                    }}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="login_heading">Image<span className="danger fs-14 fw-400 mt-1">*(Extension: jpg. jpeg.webp) Note:Dimension Size 1000x600 px</span></label>
                                <div className="position-relative select_file ">
                                    <input
                                        type="file"
                                        name="mainImage"
                                        className="choose-file"
                                        accept="image/jpeg, image/jpg, image/webp"
                                        {...registerStepOne("mainImage", {
                                            required: true,
                                            message: "this is required",
                                        })}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                const file = e.target.files[0];
                                                const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                                                if (!validTypes.includes(file.type)) {
                                                    toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                                                    e.target.value = null; // Clear the input value
                                                } else {
                                                    setUploadedDocuments1(file);
                                                }
                                            }
                                        }}
                                    />

                                </div>
                                {packages.mainImage && (
                                    <p className="text-success fs-14 fw-400 my-1">Selected file: {packages.mainImage}</p>
                                )}
                                {errorsStepOne.mainImage && (
                                    <p className="danger fs-14 fw-400 my-1">{errorsStepOne.mainImage.message}</p>
                                )}
                            </div>
                            <div className="col-md-12 px-0" >
                                <div className="row  Highlightedsections p-3">
                                    <div className="d-flex justify-content-start my-2">
                                        <input
                                            type="checkbox"
                                            name="ismocktest"
                                            checked={ismocktest}
                                            onChange={() => setIsMocktest(!ismocktest)}
                                        />
                                    </div>
                                    {additionalInputs.map((value, index) => (
                                        <div key={index} className="row m-0 p-0">


                                            <div className="col-md-6">

                                                <CustomDropDown
                                                    labelTitle="Select Mock Test"
                                                    placeholder="Select"
                                                    name={value.name}
                                                    id={value.name}
                                                    additionalClasses="profile_edit"
                                                    inputType={InputType.text}
                                                    // showError={errorsStepOne[value.name]}
                                                    // errorMessage={errorsStepOne[value.name]?.message}
                                                    resetValue={resetMockTest}
                                                    setResetValue={setResetMockTest}
                                                    register={registerStepOne}
                                                    // showMandatory={true}
                                                    setValue={setValuesStepOne}
                                                    labelClass="customtextcolorlabel"
                                                    options={
                                                        packs?.filter((e) => additionalInputs.findIndex((data) => getValuesStepOne(data.name) === e._id) === -1)
                                                            .map((e) => {
                                                                return { value: e._id, label: e.mockTestName };
                                                            })}
                                                    defaultOption={() => {
                                                        const subject = packages?.mockTests && (packages.mockTests.length >= index - 1) ? packages?.mockTests[index]?.mockTest : null
                                                        return packs ? { value: subject?._id, label: subject?.mockTestName ? subject?.mockTestName : "Select" } : null
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <CustomTextField
                                                    labelTitle="No. of Attempts"
                                                    placeholder="No. of Attempts"
                                                    name={value.value}
                                                    id={value.value}
                                                    inputType={InputType.number}
                                                    // showError={errorsStepOne[value.value]}
                                                    // errorMessage={errorsStepOne[value.value]?.message}
                                                    register={registerStepOne}
                                                    additionalClasses="profile_edit"
                                                    labelClass="customtextcolorlabel"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex align-items-center gap-2 profile" onClick={handleAddMore} >
                                            <Image src={SvgImages.addbutton} />
                                            <h3 className="add_more mb-0 " >Add More</h3>
                                        </div>

                                        {
                                            (deleteInput || isEditMode) && additionalInputs.length > 0 && (
                                                <div className="d-flex align-items-center gap-2 text-danger mt-2 profile" onClick={() => handleDelete(additionalInputs.length - 1)}>
                                                    <Image src={SvgImages.deleteIcon} style={ImageFilters.red} alt="Delete Icon" />
                                                    <h3 className="fw-500 fs-14 mb-0" > Delete </h3>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="d-flex align-items-center Highlightedsections mt-4 gap-3 p-3">
                                    <input
                                        type="checkbox"
                                        name="bharatSatExam"
                                        checked={bharatSatExam}
                                        register={registerStepOne}
                                        onChange={() => setBharatSatExam(!bharatSatExam)}
                                    />
                                    <h3 className="fw-500 fs-14  mb-0">Bharat Sat Exam</h3>
                                </div>

                                <div className="  d-flex align-items-center Highlightedsections mt-4 gap-3 p-3 mb-4">
                                    <input
                                        type="checkbox"
                                        name="paidsyllabus"
                                        checked={paidsyllabus}
                                        onChange={() => setPaidSyllabus(!paidsyllabus)}
                                    />
                                    <h3 className="fw-500 fs-14  mb-0"> Pradnya Learnitics</h3>
                                </div>

                            </div>

                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Actual Price inclusive of GST"
                                    placeholder="Actual Price"
                                    name="actualPrice"
                                    id="actualPrice"
                                    inputType={InputType.number}
                                    showMandatory={true}
                                    register={registerStepOne}
                                    additionalClasses="profile_edit"
                                    showError={errorsStepOne?.actualPrice}
                                    errorMessage={errorsStepOne?.actualPrice?.message}
                                />
                            </div>

                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Discounted Price inclusive of GST (Number)"
                                    placeholder="Discounted Price"
                                    name="discountedPrice"
                                    id="discountedPrice"
                                    inputType={InputType.number}
                                    showMandatory={false}
                                    register={registerStepOne}
                                    additionalClasses="profile_edit"
                                    showError={errorsStepOne?.discountedPrice}
                                    errorMessage={errorsStepOne?.discountedPrice?.message}
                                />
                            </div>

                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Price After Coordinator Discount"
                                    placeholder="Discount"
                                    name="discountCoordinator"
                                    id="discountCoordinator"
                                    inputType={InputType.number}
                                    showMandatory={false}
                                    register={registerStepOne}
                                    additionalClasses="profile_edit"
                                    showError={errorsStepOne?.discountCoordinator}
                                    errorMessage={errorsStepOne?.discountCoordinator?.message}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Validity in Days(Number)"
                                    placeholder="Validity in Days"
                                    name="validityInDays"
                                    id="validityInDays"
                                    inputType={InputType.number}
                                    showMandatory={true}
                                    register={registerStepOne}
                                    additionalClasses="profile_edit"
                                    showError={errorsStepOne?.validityInDays}
                                    errorMessage={errorsStepOne?.validityInDays?.message}
                                />
                            </div>

                            <CustomTextEditor
                                labelTitle={"Details"}
                                name="details"
                                id="details"
                                setValue={setValuesStepOne}
                                showError={errorsStepOne?.details}
                                errorMessage={errorsStepOne?.details?.message}
                                showMandatory={true}
                                defaultValue={packages?.details || ""}
                            />

                            <div className="d-flex justify-content-end mt-3">
                                <ButtonWithIcon
                                    text={packages?._id ? "Update" : "Submit"}
                                    icon={SvgImages.tick_mark}
                                    onClick={handleSubmit(onSubmit)}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddPackages;
